import React, { Component } from 'react'
import { GetMyDeveloperLicenses, GetMyPeripheralLicenses } from "../api/licenses"
import { Alert, Row, Col, Button } from 'react-bootstrap'
import DeveloperLicense from "./developer-license"
import PeripheralLicense from "./peripheral-license"
import RegisterKey from "./register-key"
import StatusMessage from "../lib/statusmessage"


class MyLicenses extends Component {

    constructor(props) {
        super(props);
        this.state = {
            DeveloperLicenses: null,
            PeripheralLicenses: null,
            DeveloperLicensesAlert: null,
            PeripheralLicensesAlert: null
        };
        this.GetMyDeveloperLicenses = this.GetMyDeveloperLicenses.bind(this);
        this.GetMyPeripheralLicenses = this.GetMyPeripheralLicenses.bind(this);
        this.forceUpdate = this.forceUpdate.bind(this);
    }

    async componentWillMount() {
        this.GetMyDeveloperLicenses(false);
        this.GetMyPeripheralLicenses(false);

    }

    componentDidUpdate() {
        window.location.hash = window.decodeURIComponent(window.location.hash);
        const scrollToAnchor = () => {
            const hash = window.location.hash;
            if(hash !=="")
                document.querySelector(`${hash}`).scrollIntoView();
          
        };
        scrollToAnchor();
        window.onhashchange = scrollToAnchor;
      }

    async forceUpdate() {
        this.GetMyDeveloperLicenses(true);
        this.GetMyPeripheralLicenses(true);
    }

    async GetMyDeveloperLicenses(force = false) {
        try {
            this.setState({
                DeveloperLicenses: null,
                DeveloperLicensesAlert:null
            })
            let _licenses = await GetMyDeveloperLicenses(force);
            this.setState({
                DeveloperLicenses: _licenses || []
            })
        } catch (ex) {
            this.setState({
                DeveloperLicensesAlert: new StatusMessage({
                    Status: 'danger',
                    Message: 'There was an error trying to load your licenses.  Please try again.'
                }),
                DeveloperLicenses: []
            })
        }


    }
    async GetMyPeripheralLicenses(force) {
        try {
            this.setState({
                PeripheralLicenses: null,
                PeripheralLicensesAlert: null
            })
            let _licenses = await GetMyPeripheralLicenses(force);
            if (_licenses.Code == 0) {
                this.setState({
                    PeripheralLicenses: _licenses.Value.Entitlements || []
                })
            }

        } catch (ex) {
            this.setState({
                PeripheralLicensesAlert: new StatusMessage({
                    Status: 'danger',
                    Message: 'There was an error trying to load your licenses.  Please try again.'
                }),
                PeripheralLicenses: []
            })
        }
    }

    render() {
        return (<div className="myaccount-licenses">
            <h2>My Licenses</h2>
            <p>If you have questions on any of our licenses, please submit a support ticket and include "Licensing" in the title.</p>
            <a href="/my-account/my-support" target="_blank">Submit a support ticket.</a>

            <ul>
                <li>
                    <a href="#register">Register A Serial Key</a>
                </li>
                <li>
                    <a href="#licenses">Developer Licenses</a>
                </li>
                <li>
                    <a href="#distribution">Distribution Licenses</a>
                </li>
            </ul>

            <div id={`register`}>
            <RegisterKey />
            </div>
            
            <div id={`licenses`}>
                <Row>
                    <Col className={"col-md-8"}>
                        <h3 id="licenses">Developer Licenses</h3>
                    </Col>
                    <Col className={"col-md-4 mt-5"}>
                        <button type="button" className={"gc-btn secondary-action"} onClick={this.forceUpdate}>Refresh All</button>
                    </Col>
                </Row>
            </div>

            <div id={'developer'}>
            <div className='container'>
                {((t) => {
                    if (this.state.DeveloperLicensesAlert) {
                        return (
                            <Alert variant={t.state.DeveloperLicensesAlert.Status}>
                                {t.state.DeveloperLicensesAlert.Message}
                            </Alert>
                        )
                    }

                    if (t.state.DeveloperLicenses) {
                        if (t.state.DeveloperLicenses != null && t.state.DeveloperLicenses.length > 0) {
                            var licenselist = t.state.DeveloperLicenses.map((license, idx) => {
                                return <DeveloperLicense key={Math.random().toString()} license={license} onUpdated={this.forceUpdate} />
                            })
                            return <div>{licenselist}</div>

                        } else {
                            return (<p>
                                <strong>You have no licenses registered to your account.</strong>
                            </p>)
                        }
                    } else {
                        return (<div><i className="fa fa-spinner fa-spin"></i></div>)
                    }


                })(this)}
            </div>
            </div>

            <div id={'distribution'}>
            <div id={`distribution-head`}>
                <Row>
                    <Col className={"col-md-8"}>
                        <h3 id="distribution">Distribution Licenses</h3>
                    </Col>
                    <Col className={"col-md-4  mt-5"}>
                        <button type="button" className={"gc-btn secondary-action"} onClick={this.forceUpdate}>Refresh All</button>
                    </Col>
                </Row>
            </div>
            </div>
            
            <div className="container">

                <p>Before deploying your application publicly, you'll need to create and add a distribution key for the domain(s). Failing
        to add a distribution key will result in interruption of the app's operation.​</p>

                <a href="/licensing/generate-distribution-key">Read more about distribution keys.</a>

                {((t) => {
                    if (this.state.PeripheralLicensesAlert) {
                        return (
                            <Alert variant={t.state.PeripheralLicensesAlert.Status}>
                                {t.state.PeripheralLicensesAlert.Message}
                            </Alert>
                        )
                    }
                    if (t.state.PeripheralLicenses) {
                        if (t.state.PeripheralLicenses != null && t.state.PeripheralLicenses.length > 0) {
                            var licenselist = t.state.PeripheralLicenses.map((license, idx) => {
                                return <PeripheralLicense key={license.LicenseID + license.updated} license={license} onUpdated={this.forceUpdate} />
                            })
                            return <div className="container">{licenselist}</div>

                        } else {
                            return (<p>
                                <strong>You have no registered licenses. If your serial key is not registered, the license will not show on your
                                list. Register your serial key in the box at the top of the page. Your serial key was sent when the
                                purchase was completed; if you didn't purchase the product personally, check with your procurement
                                officer.
                                </strong>
                            </p>)
                        }
                    } else {
                        return <div><i className="fa fa-spinner fa-spin"></i></div>
                    }
                })(this)}
            </div>
            
        </div>)
    }
}

export default MyLicenses